import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { getIsAuthenticated } from 'store/user';

import AuthMinimalLayout from 'components/Layout/AuthMinimalLayout/AuthMinimalLayout';

const NoAuthRouteMinimalLayout = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const location = useLocation();
  const from = location.state?.from;
  if (isAuthenticated) {
    if (from) {
      return <Navigate to={from} replace />;
    } else {
      return <Navigate to='/results' replace />;
    }
  } else {
    return <AuthMinimalLayout />;
  }
};
export default NoAuthRouteMinimalLayout;
